import { useState, useEffect } from "react";
import { ArrowLeft } from "lucide-react";
import api from "../../services/api";

export default function PolicyForm({ policy, onSave, onCancel }) {
  var insurersState = useState([]);
  var insurers = insurersState[0];
  var setInsurers = insurersState[1];
  var brokersState = useState([]);
  var brokers = brokersState[0];
  var setBrokers = brokersState[1];
  var formState = useState({
    policy_number: policy ? policy.policy_number : "",
    insurer_id: policy ? policy.insurer_id : "",
    client_id: policy ? policy.client_id : "",
    client_name: policy ? policy.client_name : "",
    broker_id: policy ? policy.broker_id : "",
    insurance_type: policy ? policy.insurance_type : "auto",
    coverage_details: policy ? (policy.coverage_details || "") : "",
    premium: policy ? policy.premium : "",
    deductible: policy ? policy.deductible : "0",
    start_date: policy ? policy.start_date : "",
    end_date: policy ? policy.end_date : "",
    status: policy ? policy.status : "ativa",
    notes: policy ? (policy.notes || "") : "",
  });
  var form = formState[0];
  var setForm = formState[1];
  var savingState = useState(false);
  var saving = savingState[0];
  var setSaving = savingState[1];

  useEffect(function() {
    api.get("/insurers?active_only=true").then(function(r) { setInsurers(r.data.insurers || []); });
    api.get("/users?role=broker").then(function(r) { setBrokers(r.data.users || []); }).catch(function() {});
  }, []);

  function handleChange(field, value) {
    setForm(function(prev) {
      var next = {};
      for (var k in prev) next[k] = prev[k];
      next[field] = value;
      return next;
    });
  }

  function handleSubmit(e) {
    e.preventDefault();
    setSaving(true);
    var payload = {
      policy_number: form.policy_number,
      insurer_id: form.insurer_id,
      client_id: form.client_id,
      client_name: form.client_name,
      broker_id: form.broker_id,
      insurance_type: form.insurance_type,
      coverage_details: form.coverage_details || null,
      premium: parseFloat(form.premium) || 0,
      deductible: parseFloat(form.deductible) || 0,
      start_date: form.start_date,
      end_date: form.end_date,
      notes: form.notes || null,
    };
    if (policy) {
      payload.status = form.status;
      api.put("/policies/" + policy.id, payload).then(function() { onSave(); }).finally(function() { setSaving(false); });
    } else {
      api.post("/policies", payload).then(function() { onSave(); }).finally(function() { setSaving(false); });
    }
  }

  var isEdit = !!policy;

  return (
    <div data-testid="policy-form">
      <button onClick={onCancel} className="flex items-center gap-1 text-sm text-gray-500 hover:text-gray-700 mb-4">
        <ArrowLeft className="w-4 h-4" />Voltar
      </button>
      <div className="bg-white rounded-xl p-6 shadow-sm border max-w-2xl">
        <h3 className="text-lg font-bold text-[#0A2F3D] mb-4">{isEdit ? "Editar Apolice" : "Nova Apolice"}</h3>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Numero da Apolice</label>
              <input required value={form.policy_number} onChange={function(e) { handleChange("policy_number", e.target.value); }} className="w-full px-3 py-2 border rounded-lg text-sm" data-testid="input-policy-number" />
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Tipo</label>
              <select required value={form.insurance_type} onChange={function(e) { handleChange("insurance_type", e.target.value); }} className="w-full px-3 py-2 border rounded-lg text-sm" data-testid="input-insurance-type">
                <option value="auto">Auto</option>
                <option value="residencial">Residencial</option>
                <option value="vida">Vida</option>
                <option value="empresarial">Empresarial</option>
              </select>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Seguradora</label>
              <select required value={form.insurer_id} onChange={function(e) { handleChange("insurer_id", e.target.value); }} className="w-full px-3 py-2 border rounded-lg text-sm" data-testid="input-insurer">
                <option value="">Selecione...</option>
                {insurers.map(function(ins) { return <option key={ins.id} value={ins.id}>{ins.name}</option>; })}
              </select>
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Corretor</label>
              <select required value={form.broker_id} onChange={function(e) { handleChange("broker_id", e.target.value); }} className="w-full px-3 py-2 border rounded-lg text-sm" data-testid="input-broker">
                <option value="">Selecione...</option>
                {brokers.map(function(b) { return <option key={b.id} value={b.id}>{b.name}</option>; })}
              </select>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Cliente (ID)</label>
              <input required value={form.client_id} onChange={function(e) { handleChange("client_id", e.target.value); }} className="w-full px-3 py-2 border rounded-lg text-sm" placeholder="ID do cliente" data-testid="input-client-id" />
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Nome do Cliente</label>
              <input required value={form.client_name} onChange={function(e) { handleChange("client_name", e.target.value); }} className="w-full px-3 py-2 border rounded-lg text-sm" data-testid="input-client-name" />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Premio Anual (R$)</label>
              <input required type="number" step="0.01" min="0" value={form.premium} onChange={function(e) { handleChange("premium", e.target.value); }} className="w-full px-3 py-2 border rounded-lg text-sm" data-testid="input-premium" />
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Franquia (R$)</label>
              <input type="number" step="0.01" min="0" value={form.deductible} onChange={function(e) { handleChange("deductible", e.target.value); }} className="w-full px-3 py-2 border rounded-lg text-sm" data-testid="input-deductible" />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Inicio Vigencia</label>
              <input required type="date" value={form.start_date} onChange={function(e) { handleChange("start_date", e.target.value); }} className="w-full px-3 py-2 border rounded-lg text-sm" data-testid="input-start-date" />
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Fim Vigencia</label>
              <input required type="date" value={form.end_date} onChange={function(e) { handleChange("end_date", e.target.value); }} className="w-full px-3 py-2 border rounded-lg text-sm" data-testid="input-end-date" />
            </div>
          </div>
          {isEdit && (
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Status</label>
              <select value={form.status} onChange={function(e) { handleChange("status", e.target.value); }} className="w-full px-3 py-2 border rounded-lg text-sm" data-testid="input-status">
                <option value="ativa">Ativa</option>
                <option value="vencida">Vencida</option>
                <option value="em_renovacao">Em Renovacao</option>
                <option value="cancelada">Cancelada</option>
              </select>
            </div>
          )}
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">Cobertura</label>
            <textarea value={form.coverage_details} onChange={function(e) { handleChange("coverage_details", e.target.value); }} rows={2} className="w-full px-3 py-2 border rounded-lg text-sm" data-testid="input-coverage" />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">Observacoes</label>
            <textarea value={form.notes} onChange={function(e) { handleChange("notes", e.target.value); }} rows={2} className="w-full px-3 py-2 border rounded-lg text-sm" data-testid="input-notes" />
          </div>
          <div className="flex justify-end gap-3 pt-2">
            <button type="button" onClick={onCancel} className="px-4 py-2 text-sm text-gray-600 hover:bg-gray-100 rounded-lg">Cancelar</button>
            <button type="submit" disabled={saving} className="px-4 py-2 bg-[#3B82F6] text-white rounded-lg text-sm font-medium hover:bg-blue-600 disabled:opacity-50" data-testid="save-policy-btn">
              {saving ? "Salvando..." : (isEdit ? "Salvar" : "Criar Apolice")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
